'use client'

import { googleSignIn } from '@/app/action/auth'
import { Button } from '@/components/ui/button'
import { FcGoogle } from 'react-icons/fc'
import { useState } from 'react'
import { cn } from '@/lib/utils'

type GoogleSignInButtonProps = {
  buttonText?: string
  redirectPath?: string
  className?: string
}

export default function GoogleSignInButton({
  buttonText = 'Sign in with Google',
  redirectPath,
  className
}: GoogleSignInButtonProps) {
  const [isLoading, setIsLoading] = useState(false)

  // Add better error handling in components/google-sign-in-button.tsx
  const handleSignIn = async () => {
    try {
      setIsLoading(true)
      await googleSignIn(redirectPath)
    } catch (error) {
      console.error('Sign-in failed:', error)

      // Add more detailed error info
      if (error instanceof Error) {
        console.error('Error message:', error.message)
        console.error('Error stack:', error.stack)
      }
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Button
      onClick={handleSignIn}
      disabled={isLoading}
      aria-busy={isLoading}
      variant='outline'
      className={cn('flex justify-center gap-2 border-border bg-secondary text-secondary-foreground hover:bg-accent dark:border-none dark:bg-slate-700 dark:hover:bg-slate-800 dark:hover:text-white', className)}
    >
      <FcGoogle className='size-5' aria-hidden='true' />
      {isLoading ? 'Signing in...' : buttonText}
    </Button>
  )
}
